<template>
	<div>
		<div class="top" @click="back" v-show="show"></div>
	</div>
</template>

<script>
	export default{
	    data(){
	        return{
	            show:false,
			}
		},
	    mounted(){
	        window.onmousewheel = ()=> {
				if(document.documentElement.scrollTop>300){
				    this.show = true;
				}else{
                    this.show = false;
				}
            }
		},
		methods:{
			back(){
				window.scrollTo(0, 0);
                this.show = false;
			}
		}
	}
</script>

<style scoped>
	.top {
	    width: 40px;
	    height: 40px;
	    background: url(../../assets/images/top.png) no-repeat center #000;
	    right: 50px;
	    bottom: 10%;
	    position: fixed;
		cursor: pointer;
	}
</style>
